import React, { useEffect, useState } from "react";
import InquiryForm from "./InquiryForm";
import moment from "moment";
import { Form, message } from "antd";
import { useSearchParams } from "react-router-dom";
import {
    getInquiryImageByToken,
    getInquiryQuestionsByToken,
    updateInquiryImage,
    updateInquiryResponses,
} from "../../api/EmployeeInquiryApi";
import { getTechSpecialized } from "../../api/TechSpecializedApi";
import { dateFormat } from "../common/GeneralConfigurations";

function ManageInquiry() {
    const [searchParams] = useSearchParams();
    const [fluencyLanguages, setFluencyLanguages] = useState({
        pt: true,
        en: false,
        es: false,
        ge: false,
        gr: false,
        it: false,
        fr: false,
    });

    const [employee, setEmployee] = useState({});
    const [techs, setTechs] = useState([]);
    const [invalidToken, setInvalidToken] = useState(false);
    const [image, setImage] = useState(null);
    const [birthDate, setBirthDate] = useState(null);
    const [tech, setTech] = useState(null);
    const [birthPlace, setBirthPlace] = useState(null);
    const [form] = Form.useForm();

    const fetchEmployeeQuestions = async () => {
        if (!searchParams.get("token")) {
            setInvalidToken(true);
            return;
        }

        const res = await getInquiryQuestionsByToken(searchParams.get("token"));
        if (res.status == 400 || res.status == 404) {
            setInvalidToken(true);
            return;
        }

        const resImage = await getInquiryImageByToken(searchParams.get("token"));
        setImage(resImage.data.image);

        const {
            name,
            birthDate,
            isEmailEnglishLanguage,
            question1,
            question2,
            question3,
            question4,
            question5,
            question6,
        } = res.data;
        const splitName = name.split(" ");

        setEmployee({
            firstName: splitName[0],
            lastName: splitName.length > 1 ? splitName[splitName.length - 1] : null,
            birthDate: null,
            isEmailEnglishLanguage: isEmailEnglishLanguage,
            q1: question1,
            q2: question2,
            q3: question3,
            q4: question4,
            q5: question5,
            q6: question6,
        });

        setBirthDate(
            birthDate === null
                ? null
                : moment(JSON.stringify(birthDate).substring(1, 11), dateFormat)
        );
    };

    const disabledDate = (current) => {
        if (
            moment().year() - current.year() < 18 ||
            moment().year() - current.year() > 120
        )
            return true;
        if (moment().year() - current.year() == 18) {
            if (moment().month() < current.month()) return true;
            if (moment().month() == current.month()) {
                if (moment().date() < current.date()) return true;
            }
        }
        return false;
    };

    const fetchTechs = async () => {
        const res = await getTechSpecialized();
        setTechs(res.data);
    };

    useEffect(() => {
        fetchEmployeeQuestions();
        fetchTechs();
    }, []);

    useEffect(() => {
        form.resetFields();
    }, [employee]);

    function getBase64(img, callback) {
        const reader = new FileReader();
        reader.addEventListener("load", () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    const saveImage = async (img) => {
        let myFormData = new FormData();
        myFormData.append("Image", img);
        myFormData.append("Token", searchParams.get("token"));
        const res = await updateInquiryImage(myFormData);
        if (res.status != 200) {
            message.error("Fail to upload photo");
            return;
        }
        getBase64(img, setImage);
    };

    const handleFinish = async (values) => {
        //if (image != null) {
            const filteredLanguages = Object.keys(fluencyLanguages).filter(
                (key) => fluencyLanguages[key]
            );
            const formattedBirthDate = moment(values.birthDate).format('YYYY-MM-DD');

            const res = await updateInquiryResponses(searchParams.get("token"), {
                ...values,
                languages: filteredLanguages.join(","),
                birthDate: formattedBirthDate,
                techSpecializedId: tech,
                placeOfBirth: birthPlace,
            });
            if (res.status == 200) {
                setInvalidToken(true);
                message.success("Inquiry answered with success");
                return;
            }
            if (res.status == 404) {
                setInvalidToken(true);
                return;
            }
            message.error("Fail to send Inquiry");
        //} else {
        //    message.error("Upload an image");
        //}
    };

    const changeBirthDate = (date) => {
        const adjustedDate = date ? moment(date).startOf('day') : null;
        setBirthDate(adjustedDate);
    };

    return (
        <>
            <InquiryForm
                fluencyLanguages={fluencyLanguages}
                setFluencyLanguages={setFluencyLanguages}
                saveImage={saveImage}
                image={image}
                disabledDate={disabledDate}
                employee={employee}
                form={form}
                techs={techs}
                handleFinish={handleFinish}
                invalidToken={invalidToken}
                birthDate={birthDate}
                changeBirthDate={changeBirthDate}
                birthPlace={birthPlace}
                changeBirthPlace={(e) => setBirthPlace(e.target.value)}
                tech={tech}
                changeTech={setTech}
            />
        </>
    );
}

export default ManageInquiry;
